// The index of the guide in the side panel, built as the index of a
// Parliament record (components/parliament/SectionIndex.tsx): the panel's
// title with its chevron and one row per section, the entry an accent text
// link, as the index's. A native anchor, not a router Link: the jump scrolls by
// itself (main.tsx mounts no ScrollRestoration) and the page is not remounted.
import { INDEX_TITLE } from "../../components/parliament/SectionIndex";
import { PanelTitle } from "../../components/sidebar/panels";
import type { GuideSection } from "./content";

type GuideIndexProps = {
  sections: readonly GuideSection[];
  /** The section whose anchor is in the address (aria-current); null without one. */
  currentId: string | null;
  /** Closes the panel: the chevron of the title (NewsLayout). */
  onCollapse: () => void;
};

export function GuideIndex({ sections, currentId, onCollapse }: GuideIndexProps) {
  return (
    <nav aria-label={INDEX_TITLE} className="flex flex-col gap-[30px]">
      <PanelTitle title={INDEX_TITLE} onCollapse={onCollapse} />
      <ul className="flex flex-col">
        {sections.map((section) => (
          <li key={section.id} className="py-2 text-sm leading-6 text-muted">
            <a
              href={`#${section.id}`}
              aria-current={currentId === section.id ? "true" : undefined}
              className="cursor-pointer rounded-sm text-sm leading-6 font-medium text-accent"
            >
              {section.title}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
